import React, { ReactElement, FC, SVGProps } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components/macro'

const MenuItemWrapper = styled(Link)<{ checked: boolean }>`
  cursor: pointer;
  display: flex;
  padding: 5px 40px;
  align-items: center;
  fill: ${({ theme: { colors }, checked }) => (checked ? colors.pumpkinOrange : colors.white)};
  color: ${({ theme }) => theme.colors.white};

  span {
    padding-left: 1em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  :hover {
    fill: ${({ theme }) => theme.colors.pumpkinOrange};
    color: ${({ theme }) => theme.colors.pumpkinOrange};
    background-color: ${({ theme }) => theme.colors.mainPressed};
  }
`

type Props = {
  active?: boolean
  link: string
  text: string
  icon?: ReactElement<FC<SVGProps<SVGSVGElement>>>
}

export const MenuItem = ({ active, link, text, icon }: Props) => (
  <MenuItemWrapper to={link} checked={!!active}>
    {icon}
    <span>{text}</span>
  </MenuItemWrapper>
)
